import FluxUtils from 'flux/utils';

import AuthenticationActions from 'sharedreact/actions/AuthenticationActions';
import NavigationActions from 'sharedreact/actions/NavigationActions';
import AccountSlideOut from 'sharedreact/components/AccountSlideOut';
import AuthenticationStore from 'sharedreact/stores/AuthenticationStore';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import asFunctional from 'sharedreact/components/asFunctional';

function handleClose (): void {
  AuthenticationActions.hideSlideOut();
}

function handleChangePassword (): void {
  /* setTimeOut( */
  handleClose();
  NavigationActions.showDialog('shared.view.changepassword');
  /* ); */
}

type State = ConstructorParameters<typeof AccountSlideOut>[0];

function getStores () {
  return [
    AuthenticationStore,
    SettingsStore
  ];
}

function calculateState (prevState?: State): State {
  return {
    activeUser: AuthenticationStore.getUser(),
    locations: AuthenticationStore.getLocations(),
    language: SettingsStore.getLanguage(),
    show: AuthenticationStore.getState().isSlideOutVisible,

    onChangePassword: handleChangePassword,
    onClose: handleClose
  };
}

export default FluxUtils.Container.createFunctional(
  asFunctional(AccountSlideOut),
  getStores,
  calculateState
);
